import cx from 'classnames'
import { Document } from 'services/DocumentService'
import DocumentItem from './DocumentItem'

interface DocumentListProps {
  aol: string
  documents: Document[]
  selectedDocuments: Document[]
  focusedId?: string | null
  pageId: string
  selectable?: boolean
  expanded: boolean
  rootId?: string
  favourites?: Set<string>
}

export default function DocumentList ({
  aol,
  documents,
  selectedDocuments,
  focusedId,
  pageId,
  selectable = true,
  expanded,
  rootId,
  favourites
}: DocumentListProps): JSX.Element {
  return (
    <>
      {documents.length > 0 && (
        <div className='dn-m flex pv3 f6 bb bb-light-bluish-grey bg-precedents-blue-10 basis-100'>
          <div className='ml6'>
            Documents
          </div>

          <div className='flex mlauto mr6'>
            <div>Automated</div>
            <div className={cx({ mh6: selectable, ml6: !selectable })}>Download</div>
            {selectable && (
              <div>Select</div>
            )}
          </div>
        </div>
      )}
      <ol className='list-reset ma0 pa0 basis-100'>
        {documents.map((document, index) => {
          return (
            <DocumentItem
              key={`${document.id}-${index}`}
              {...document}
              selectedDocuments={selectedDocuments}
              aol={aol}
              focusedId={focusedId}
              pageId={pageId}
              selectable={selectable}
              expanded={expanded}
              rootId={rootId}
              favourites={favourites}
            />
          )
        })}
      </ol>
    </>
  )
}
